import { render, staticRenderFns } from "./TabsModule.vue?vue&type=template&id=2a9a7a15"
import script from "./TabsModule.vue?vue&type=script&lang=js"
export * from "./TabsModule.vue?vue&type=script&lang=js"
import style0 from "./TabsModule.vue?vue&type=style&index=0&id=2a9a7a15&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports